import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface LogoutConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const LogoutConfirmDialog = ({ open, onClose, onConfirm }: LogoutConfirmDialogProps) => {
  const { t } = useTranslation();
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="logout-dialog-title"
      aria-describedby="logout-dialog-description"
      slotProps={{
        paper: {
          sx: {
            borderRadius: 3,
            minWidth: 320,
          }
        }
      }}
    >
      <DialogTitle id="logout-dialog-title" sx={{ pb: 1 }}>
        {t('appBar.logoutDialogTitle', { ns: 'common' })}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="logout-dialog-description">
          {t('appBar.logoutDialogDescription', { ns: 'common' })}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            px: 4,
          }}
        >
          {t('appBar.cancelButton', { ns: 'common' })}
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
        >
          {t('appBar.logoutButton', { ns: 'common' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutConfirmDialog; 